import * as React from "react"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import PropTypes from "prop-types"
import { ReactComponent as ChevronRight } from "src/v2/assets/icons/chevron-right-icon.svg"
import { ReactComponent as ChevronLeft } from "src/v2/assets/icons/chevron-left-icon.svg"
import theme from "src/v2/theme/theme"

const TabsWrappedLabel = ({ tabs }) => {
    const [value, setValue] = React.useState(tabs?.[0]?.value || "")

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ position: "relative" }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="wrapped label tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    slots={{
                        StartScrollButtonIcon: ChevronLeft,
                        EndScrollButtonIcon: ChevronRight,
                    }}
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: theme.palette.icon.white,
                            opacity: "89.8%",
                            height: "1px",
                        },
                    }}
                    sx={{
                        "& .MuiTab-root": {
                            minHeight: 0,
                            textTransform: "uppercase",
                            letterSpacing: "0.24em",
                            fontWeight: 700,
                            p: 3.4,
                        },
                        "& .MuiTabs-indicator": {
                            zIndex: 1,
                        },
                        "& .MuiTabs-scroller": {
                            maskImage:
                                "linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 16px, rgba(255, 255, 255, 1) calc(100% - 16px), rgba(255, 255, 255, 0) 100%)",
                            WebkitMaskImage:
                                "linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 16px, rgba(255, 255, 255, 1) calc(100% - 16px), rgba(255, 255, 255, 0) 100%)",
                        },
                        "& .MuiTabs-scrollButtons": {
                            color: theme.palette.icon.white,
                            width: "28px",
                            "&.Mui-disabled": {
                                visibility: "hidden",
                            },
                        },
                        "& .MuiTabs-scrollButtons:first-of-type": {
                            display: "flex",
                            justifyContent: "flex-end",
                            left: 0,
                            backgroundColor: "transparent",
                        },
                        "& .MuiTabs-scrollButtons:last-of-type": {
                            display: "flex",
                            justifyContent: "flex-start",
                            right: 0,
                            backgroundColor: "transparent",
                        },
                        "& .MuiTabs-scrollButtons:first-of-type svg": {
                            display: "flex",
                            justifyContent: "flex-end",
                            left: "7px",
                            width: "16px",
                            transform: "translate(8px, 1px)",
                        },
                        "& .MuiTabs-scrollButtons:last-of-type svg": {
                            display: "flex",
                            justifyContent: "flex-start",
                            right: "7px",
                            width: "16px",
                            transform: "translate(-8px, 1px)",
                        },
                    }}
                >
                    <Box>
                        <Box
                            sx={{
                                position: "absolute",
                                bottom: 0,
                                width: "100%",
                                height: "1px",
                                backgroundColor: "#FFFFFF4D",
                                zIndex: 0,
                            }}
                        />
                    </Box>
                    {tabs.map((tab) => {
                        const isActive = value === tab.value
                        return (
                            <Tab
                                key={tab.value}
                                value={tab.value}
                                label={tab.label}
                                isactive={isActive ? 1 : 0}
                                sx={(theme) => ({
                                    color: theme.palette.primary.white70,
                                    marginLeft: "8px",
                                    "&.Mui-selected": {
                                        color: theme.palette.white.main,
                                        backgroundColor: "transparent",
                                    },
                                })}
                            />
                        )
                    })}
                </Tabs>
            </Box>

            {tabs.map((tab) =>
                tab.value === value ? (
                    <Box key={tab.value}>{tab.content}</Box>
                ) : null
            )}
        </Box>
    )
}

TabsWrappedLabel.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            content: PropTypes.node,
        })
    ).isRequired,
}

export default TabsWrappedLabel
